import { render, staticRenderFns } from "./OrderListPage.vue?vue&type=template&id=b9566350&scoped=true&"
import script from "./OrderListPage.vue?vue&type=script&lang=js&"
export * from "./OrderListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9566350",
  null
  
)

export default component.exports